"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorRenewalPolicyDetailsWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconAccordion_1 = require("../../../../components/FalconAccordion");
var services_1 = require("@falcon/services");
var AnnualMotorRenewalPolicyDetailsWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorRenewalPolicyDetailsWidget, _super);
    function AnnualMotorRenewalPolicyDetailsWidget(props) {
        var _this = _super.call(this, props) || this;
        var paymentOption = _this.props.interaction.factors ? _this.props.interaction.factors.premiumType : undefined;
        _this.state = {
            paymentOption: paymentOption
        };
        return _this;
    }
    AnnualMotorRenewalPolicyDetailsWidget.prototype.render = function () {
        var isAccordionOpen = this.props.interaction.uistate.referrerMtaJourney === services_1.INTERACTION_PROCESS_RENEWAL_CANCELLATION;
        return (React.createElement("div", { className: "section-panel text-center annual-motor-renewal policy-details-section" },
            React.createElement("div", { className: "mt-3 panel-detail-output-entity" },
                React.createElement(FalconAccordion_1.FalconAccordion, { isOpen: isAccordionOpen, togglePositionTop: true, toggleHidden: React.createElement("div", { className: "toggle d-flex justify-content-between align-items-center" },
                        React.createElement("span", null),
                        React.createElement("span", { className: "font-weight-bold text-center fs-18 toggle-title collapsed-title" }, "Policy details"),
                        React.createElement("span", { className: "toggle-icon expand-icon" })), toggleShown: React.createElement("div", { className: "toggle toggle-show d-flex justify-content-between align-items-center" },
                        React.createElement("span", null),
                        React.createElement("span", { className: "font-weight-bold text-center fs-18 toggle-title" }, "Policy details"),
                        React.createElement("span", { className: "toggle-icon collapse-icon" })) }, this.renderPolicyDetails(this.props.interaction)))));
    };
    AnnualMotorRenewalPolicyDetailsWidget.prototype.renderPolicyDetails = function (interaction) {
        return (React.createElement("div", { className: "margin-bottom-24 padding-bottom-16" },
            React.createElement("div", { className: "accordion-content reset-paddings grid-make-2-col" },
                this.renderQuestions(),
                React.createElement("div", { className: "detail pt-4" },
                    React.createElement("div", { className: "detail-key" }, "Breakdown cover:"),
                    this.renderBreakdown(this.props.interaction.optionalExtras)),
                React.createElement("div", { className: "detail pt-4" },
                    React.createElement("div", { className: "detail-key" }, "Protected no claim discount:"),
                    React.createElement("div", { className: "detail-value" }, this.props.interaction.policyHolder.ncd.doNotDisclose ? "Included" : "Not included")),
                services_1.InteractionHelper.isPolicyQuotedBeforeFamilyCoverRemoval(interaction) &&
                    React.createElement("div", { className: "detail pt-4" },
                        React.createElement("div", { className: "detail-key" }, "Family Package:"),
                        React.createElement("div", { className: "detail-value" }, this.props.interaction.optionalExtras.familyPackage ? "Included" : "Not included")))));
    };
    ;
    AnnualMotorRenewalPolicyDetailsWidget.prototype.renderQuestions = function () {
        return React.createElement(plugin_journey_1.QuestionList, __assign({}, this.props, { questions: this.props.question.questions }));
    };
    AnnualMotorRenewalPolicyDetailsWidget.prototype.renderBreakdown = function (optionalExtras) {
        switch (optionalExtras.breakdownCoverLevel) {
            case services_1.BreakdownCoverLevelEnum.LOCAL:
                return React.createElement("div", { className: "detail-value" }, "Included (Local)");
            case services_1.BreakdownCoverLevelEnum.UK:
                return React.createElement("div", { className: "detail-value" }, "Included (National)");
            case services_1.BreakdownCoverLevelEnum.EU:
                return React.createElement("div", { className: "detail-value" }, "Included (European)");
            default:
                return React.createElement("div", { className: "detail-value" }, "Not included");
        }
    };
    return AnnualMotorRenewalPolicyDetailsWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorRenewalPolicyDetailsWidget = AnnualMotorRenewalPolicyDetailsWidget;
//# sourceMappingURL=AnnualMotorRenewalPolicyDetailsWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/renewal/AnnualMotorRenewalPolicyDetailsWidget.js
// module id = 3187
// module chunks = 0